import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import GoogleAnalytics from './components/GoogleAnalytics/GoogleAnalytics';
import Home from './pages/Home/Home';
import Services from './pages/Services/Services';
import About from './pages/About/About';
import Industries from './pages/Industries/Industries';
import Technologies from './pages/Technologies/Technologies';
import Contact from './pages/Contact/Contact';

/** Legacy routes → renamed pages or home sections. */
const LEGACY_REDIRECTS = [
  { path: '/sectors', to: '/industries' },
  { path: '/portfolio', to: '/#work' },
  { path: '/career', to: '/' },
];

function RouteScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.pageYOffset > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Router>
      <div className="App">
        <GoogleAnalytics />
        <RouteScroll />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/technologies" element={<Technologies />} />
            <Route path="/contact" element={<Contact />} />
            {LEGACY_REDIRECTS.map(({ path, to }) => (
              <Route
                key={path}
                path={path}
                element={<Navigate to={to} replace />}
              />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTop show={showScrollTop} onClick={scrollToTop} />
      </div>
    </Router>
  );
}

export default App;
